import { Controller } from "@hotwired/stimulus"

// Shows a loading overlay when forms are submitted within this controller's scope.
// The overlay is automatically removed when Turbo replaces the frame content.
export default class extends Controller {
  static values = { message: { type: String, default: "Generating insight..." } }

  connect() {
    this.boundShowLoading = this.showLoading.bind(this)
    document.addEventListener("turbo:submit-start", this.boundShowLoading)
  }

  disconnect() {
    document.removeEventListener("turbo:submit-start", this.boundShowLoading)
  }

  showLoading(event) {
    // Only show loading if the form is within this controller's element
    if (!this.element.contains(event.target)) {
      return
    }

    // Create loading overlay
    const overlay = document.createElement("div")
    overlay.className = "loading-overlay"
    overlay.innerHTML = `
      <div class="loading-spinner"></div>
      <span class="loading-message">${this.messageValue}</span>
    `

    // Add overlay to the element
    this.element.style.position = "relative"
    this.element.appendChild(overlay)
  }
}
